document.addEventListener('DOMContentLoaded', () => {
  function getIDfromYouTubeURL(url) {
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
    var match = url.match(regExp);
    return match && match[7].length == 11 ? match[7] : false;
  }
  function getIDfromVimeoURL(url) {
    var regExp = /^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/))?([0-9]+)/;
    var match = url.match(regExp);
    return match && match[5] ? match[5] : false;
  }
  function initClickHandlers() {
    const videoElement = document.querySelector('.photo-section[data-video-url]');
    const videoModalElement = document.querySelector('.video-modal');
    const videoModalContent = videoModalElement?.querySelector('.video-modal-content');
    const videoModalBg = document.querySelector('.video-modal-bg[data-video-modal-close]');
    
    if (videoElement && videoModalContent) {
      videoElement.addEventListener('click', () => {
        const videoURL = videoElement.dataset.videoUrl;
        if (videoURL) {
          let modalhtml = '<button class="modal-close" data-video-modal-close></button>';
          if (videoURL.indexOf('youtube') != -1) {
            modalhtml += '<iframe src="https://www.youtube.com/embed/' + getIDfromYouTubeURL(videoURL) + '?rel=0&autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
          } else if (videoURL.indexOf('vimeo') != -1) {
            modalhtml += '<iframe src="https://player.vimeo.com/video/' + getIDfromVimeoURL(videoURL) + '?autoplay=1&title=0&byline=0&portrait=0&color=e42229" frameborder="0" allowfullscreen></iframe>';
          }
          videoModalContent.innerHTML = modalhtml;
          videoModalContent.querySelector('.modal-close[data-video-modal-close]')?.addEventListener('click', () => {
            videoModalContent.innerHTML = '';
            document.querySelector('html').classList.remove('video-modal-open');
          });
          document.querySelector('html').classList.add('video-modal-open');
        }
      });
    }
  
    if (videoModalBg && videoModalContent) {
      videoModalBg.addEventListener('click', () => {
        videoModalContent.innerHTML = '';
        document.querySelector('html').classList.remove('video-modal-open');
      });
    }
  }
  
  initClickHandlers();
})